import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['paymentTermsForm', 'paymentSourceTypeForm', 'autoChargeEnabledForm']

  submitPaymentSourceType() {
    this.paymentSourceTypeFormTarget.requestSubmit()
  }

  submitPaymentTerms() {
    this.paymentTermsFormTarget.requestSubmit()
  }

  submitAutoChargeEnabled() {
    this.autoChargeEnabledFormTarget.requestSubmit()
  }
}
